import React, { Component } from "react";
import { Spinner } from "../../Components/Spinner/Spinner";

import Select from "react-select";
import { immediateToast } from "izitoast-react";
import { Select_Option } from "../../assets/Js/errorMessage";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { callAPI } from "../../assets/Js/backendCommunication";

import { getPlainToken, getToken } from "../../assets/Js/tokenHandler";

import projectSettings from "../../assets/Js/projectSettings";

import { closeModel } from "../../assets/Js/closeModel";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import trackChanged from "../../redux/actionCreators/trackChanged";
const mapStateToProps = (state) => ({
  userData: state.userData,
  gymData: state.gymList,
  selectedGym: state.selectedGym,
});

const mapDispatchToProps = (dispatch) => ({
  trackChanged: () => dispatch(trackChanged()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class JoinTrack extends Component {
      constructor(props) {
        super(props);
        this.state = {
          isLoading: false,
          tracks: [],
          selectTrack: "",
          privateTrack: false,
          paidTrack: false,
          trackPassword: "",
        };
      }

      componentDidMount() {
        this.props.gymData && this.getTrack();
      }

      componentWillUnmount() {
        this.props.showWelcomeNote(null, false);
      }

      static getDerivedStateFromProps = (props, state) => {
        return {
          ...state,
          selectedGym: props.selectedGym,
        };
      };

      componentDidUpdate(prevProps) {
        if (prevProps.selectedGym !== this.state.selectedGym) this.getTrack();
      }
      
      submitHandler = (e) => {
        e.preventDefault();
        this.postTrack();
      };

     

      skipHandler = () => {
        if (getPlainToken()) {
          closeModel(this.props.modalId);
          this.props.handleAddGym();
          return;
        }
        this.props.history.push("/login");
      };

      showWelcomeNoteForTracks = () => {
        let tracksList = this.props.gymData.find(
          (item) => item.Id === this.state.selectedGym.value
        );
        if (tracksList) {
          let _track = tracksList.Tracks.find(
            (s) => s.Id === this.state.selectTrack
          );
          this.props.showWelcomeNote(_track.WelcomeNote, true, _track.Name);
        }
      };

      postTrack = async () => {
        let url = `${projectSettings.baseUrl}/gyms/joingym`;
        let type = "POST";
        let header = true;
        let data = null;
        let token = getPlainToken() ? getPlainToken() : null;
        let userId = null;
        if (token) {
          userId = this.props.userData.Id;
        } else {
          userId = this.props.match.params.id;
        }

        data = {
          UserId: userId,
          TrackId: this.state.selectTrack,
          TrackPassword: this.state.trackPassword,
        };
        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(
          url,
          header,
          type,
          JSON.stringify(data),
          token
        );

        if (response) {
          this.setState({ isLoading: false });
          if (response.type === "error") {
            this.setState({ showError: true });
          } else if (response.type === "success") {
            this.props.trackChanged();
            this.setState({ showError: false });

            if (this.state.paidTrack) {
              response?.data?.SessionUrl &&
                window.location.replace(response.data.SessionUrl);
              return;
            } else if (!token && !this.state.paidTrack) {
              this.props.history.push("/login");
            }
            apiResponseToast(
              response.status,
              "joinTrack",
              response.data.message
            );
            response = "";
            if (getPlainToken()) {
              this.props.resetOnCloseModal();
              closeModel(this.props.modalId);
              this.showWelcomeNoteForTracks();
              return;
            }
          }
        }
      };

      getTrack = () => {
        if (this.state.selectedGym) {
          let tracksList = this.props.gymData.find(
            (item) => item.Id === this.state.selectedGym.value
          );

          if (tracksList) {
            let tracks = tracksList.Tracks.filter(
              (track) => !track.IsTrackJoined
            );

            const tempOptions = tracks.map((currVal, index) => ({
              value: currVal.Id,
              label: currVal.Name,
            }));
            this.setState({ tracks: tempOptions });
          }
        }
      };

      changeTrack = (track) => {
        this.setState({
          selectTrack: track,
        });
        let tracksList = this.props.gymData.find(
          (item) => item.Id === this.state.selectedGym.value
        );
        for (var i = 0; i < tracksList.Tracks.length; i++) {
          if (tracksList.Tracks[i].Id === track) {
            if (tracksList.Tracks[i].Type.toLowerCase() === "private") {
              this.setState({ privateTrack: true, paidTrack: false });
              break;
            } else if (tracksList.Tracks[i].Type.toLowerCase() === "paid") {
              this.setState({ paidTrack: true, privateTrack: false });
              break;
            }
          } else {
            this.setState({ privateTrack: false });
          }
        }
      };

      render() {
        return (
          <div className={getToken ? "" : "p-5"}>
            <h6>Select Your Track</h6>
            <form onSubmit={this.submitHandler}>
              <div className="mt-3">
                <Select
                  className="react-select"
                  options={this.state.tracks}
                  onChange={(e) => this.changeTrack(e.value)}
                />
              </div>
              {this.state.privateTrack && (
                <div className="mt-2">
                  <input
                    className="form-control"
                    onChange={(e) => {
                      this.setState({ trackPassword: e.target.value });
                    }}
                    type="text"
                    placeholder="Password"
                  />
                </div>
              )}
              <div
                className={`d-flex ${
                  getPlainToken()
                    ? "justify-content-end"
                    : "justify-content-center"
                }  mt-3 mb-3`}
              >
                {getPlainToken() && (
                  <button
                    className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
                    data-dismiss="modal"
                    onClick={this.props.resetOnCloseModal}
                  >
                    Cancel
                  </button>
                )}

                <button
                  type="submit"
                  className="basicFatBtnStyle primaryBtn"
                  disabled={this.state.isLoading || !this.state.tracks.length}
                >
                  {this.state.isLoading ? (
                    <div>
                      <Spinner />
                    </div>
                  ) : (
                    <span>Join</span>
                  )}
                </button>
              </div>
            </form>
          </div>
        );
      }
    }
  )
);
